// ! NOT Migrated

// * Use Period

import { useState } from 'react';
import { SelectOption } from '../components';

export const YEARS_LIST = Array.from(
  { length: new Date().getFullYear() - 2016 + 1 },
  (_, i) => `${2016 + i}`,
).reverse();

export const MONTHS_LIST = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const usePeriod = () => {
  const years: SelectOption[] = YEARS_LIST.map((year) => ({
    label: year,
    value: year,
  }));

  const months: SelectOption[] = MONTHS_LIST.map((month, i) => ({
    label: month,
    value: i.toString(),
  }));

  const [year, setYear] = useState(years[0]);
  const [month, setMonth] = useState(months[new Date().getMonth()]);

  const changeYear = (year: SelectOption) => {
    setYear(year);
  };

  const changeMonth = (month: SelectOption) => {
    setMonth(month);
  };

  return { years, months, year, changeYear, month, changeMonth };
};
